var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightValve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M10.891,2.578c0-0.494-0.397-0.891-0.891-0.891S9.109,2.085,9.109,2.578v0.779L5.25,2.875 c-0.657,0-1.188,0.531-1.188,1.188S4.593,5.25,5.25,5.25l3.859-0.482v2.857H2.281V7.328c0-0.494-0.397-0.891-0.891-0.891 S0.5,6.835,0.5,7.328v1.188v7.719v1.188c0,0.494,0.397,0.891,0.891,0.891s0.891-0.397,0.891-0.891v-0.297h15.438v0.297 c0,0.494,0.397,0.891,0.891,0.891c0.494,0,0.891-0.397,0.891-0.891v-1.188V8.516V7.328c0-0.494-0.397-0.891-0.891-0.891 c-0.493,0-0.891,0.397-0.891,0.891v0.297h-6.828V4.768L14.75,5.25c0.657,0,1.188-0.531,1.188-1.188s-0.531-1.188-1.188-1.188 l-3.859,0.482V2.578z M2.281,15.344V9.406H10h7.719v5.938H2.281z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightValve);
export default __webpack_public_path__ + "static/media/light-valve.8333e9923e4a36fef3262279592dda72.svg";
export { ForwardRef as ReactComponent };